import {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';

import {resetNewsLetterTypes} from 'src/hooks/dictionaries/services/dictionary-slice';
import {getSupportedNewsletterTypes} from 'src/openapi/admin/apis/NewsletterDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

import type {DictionaryTree} from 'src/openapi/admin/models/DictionaryTree';

export const useNewsletterDictionaryForUser = ({userId}: {userId: number}) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const [fullNewsletterDictionary, setFullNewsletterDictionary] = useState<DictionaryTree[]>([]);
    const [userNewsletterTypes, setUserNewsletterTypes] = useState<DictionaryTree[]>([]);

    useEffect(() => {
        let cancelled = false;

        const fetchDictionaries = async () => {
            const [fullResponse, userResponse] = await Promise.all([
                apiDispatch(getSupportedNewsletterTypes({featureForce: true})),
                apiDispatch(getSupportedNewsletterTypes({featureForce: false, userId})),
            ]);

            if (cancelled) {
                return;
            }

            if (fullResponse.payload.success) {
                setFullNewsletterDictionary(fullResponse.payload.data);
            }
            if (userResponse.payload.success) {
                setUserNewsletterTypes(userResponse.payload.data);
            }
        };

        fetchDictionaries();

        return () => {
            cancelled = true;
            dispatch(resetNewsLetterTypes());
        };
    }, [userId, apiDispatch, dispatch]);

    const availableNewsletterTypes = useMemo(() =>
        userNewsletterTypes.flatMap(item => item.children?.map(c => c.id) ?? [item.id]),
    [userNewsletterTypes]);

    return {fullNewsletterDictionary, availableNewsletterTypes};
};
